import { useContext } from 'react';

import { SlotsAPIContext } from '../../components/slots-state/SlotsAPIContext';

export const useSlotsAPI = () => useContext(SlotsAPIContext);
